module.exports = __webpack_public_path__ + "img/s1.e01940f8.jpg";